import React, { useState } from 'react'

import { isWindowEnv } from 'utils/env.utils'

import './read-more-text.scss'

const MAX_POSSIBLE_TEXT_SLICE_LENGTH = 301
const parser = isWindowEnv() && window.DOMParser ? new window.DOMParser() : null
const ReadMoreText = ({ text, asHTML }) => {
  const [isButtonClicked, setIsButtonClicked] = useState(false)
  const textLength = 300
  let maxPossibleLength = MAX_POSSIBLE_TEXT_SLICE_LENGTH
  let showReadMoreButton = text?.length > textLength && !isButtonClicked

  if (asHTML && parser) {
    let html = parser.parseFromString(text, 'text/html')
    maxPossibleLength = MAX_POSSIBLE_TEXT_SLICE_LENGTH + html.body.innerHTML.length - html.body.textContent.length
    showReadMoreButton = html.body.textContent.length > textLength && !isButtonClicked
  }

  const sliceDescription = (text = '') => {
    let sliced = text.slice(0, maxPossibleLength)

    if (sliced.indexOf('<a') > sliced.lastIndexOf('</a')) {
      let secondPart = text.slice(maxPossibleLength, text.length)
      let lostTagIndex = secondPart.indexOf('</a>')

      sliced = text.slice(0, maxPossibleLength + lostTagIndex + 3)
    }

    return sliced
  }

  const slicedDescription = sliceDescription(text)
  return (
    <>
      {!isButtonClicked && !asHTML && slicedDescription}
      {!isButtonClicked && asHTML && <div dangerouslySetInnerHTML={{ __html: slicedDescription }}></div>}
      {showReadMoreButton && (
        <span
          className='read-more-text'
          onClick={(e) => {
            e.stopPropagation()
            setIsButtonClicked(true)
          }}
        >
          &nbsp; {I18n.t('react.shared.community.read_more')} ...
        </span>
      )}

      {isButtonClicked && !asHTML && text}
      {isButtonClicked && asHTML && <div dangerouslySetInnerHTML={{ __html: text }}></div>}
    </>
  )
}

export default ReadMoreText
